var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-background"},[_c('div',{staticClass:"title-resume mb-3"},[_vm._v("Mensagem do Organizador")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.organizerInfo.mensagem)}})])}
var staticRenderFns = []

export { render, staticRenderFns }